module.exports = __webpack_public_path__ + "img/hr-rock-medium-12.8b49fbbb.png";